import {
  Card,
  Grid,
  Link,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { styles, useStyles } from "../../../styles/styles";
import STEPS from "../../../pages/register/steps";
import React from "react";
import { useNavigate } from "react-router";
import CvsButton from "../../Button";

interface DatabaseConsentProps {
  theme: string;
  skin: string;
  setStep: (e: string) => void;
  setPrevStep: (e: string) => void;
}

const DatabaseConsent = (props: DatabaseConsentProps) => {
  const { skin, setStep, setPrevStep } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <>
      <Grid style={styles.cardGrid} className={classes.cardGridMobile}>
        <Typography
          component="p"
          textAlign={"center"}
          fontSize={16}
          fontWeight={700}
          lineHeight={1.5}
          mt={2}
          className={classes.cardInnerHeading}
        >
          User Consent
        </Typography>
        <Card className={classes.consentCard}>
          <List
            sx={{
              listStyleType: "disc",
              pl: 2,
            }}
          >
            <ListItem className={classes.listText}>
              You certify that you reside in one of the following states:
              Alaska, Arkansas, Colorado, Connecticut, Delaware, Florida,
              Georgia, Idaho, Indiana, Iowa, Kansas, Kentucky, Louisiana,
              Maryland, Massachusetts, Michigan, Minnesota, Mississippi,
              Missouri, Montana, Nevada, New York, North Dakota, Ohio, Oklahoma,
              Pennsylvania, South Carolina, South Dakota, Tennessee, Texas,
              Utah, Vermont, Washington, Washington DC, West Virginia,
              Wisconsin, or Wyoming.
            </ListItem>
            <ListItem className={classes.listText}>
              If you choose to capture your selfie using the Private Identity
              application, your selfie will be processed by a neural network
              running in your browser that compares your face to your Photo ID
              in a few milliseconds. This process is fast and accurate, and does
              not keep or share your selfie.
            </ListItem>
            <ListItem className={classes.listText}>
              The biometric data is only captured and processed on your device,
              and is deleted within one second. Private Identity never
              transmits, receives, stores, manages or discloses your biometric
              data.
            </ListItem>
            <ListItem className={classes.listText}>
              Only encrypted data is sent to the Private Identity servers.
              Private Identity then confirms with third-party partners whether
              or not you have reached the identity assurance threshold required
              to create an account.
            </ListItem>
            <ListItem className={classes.listText}>
              This app is certified compliant with the IEEE 2410-2021 Standard
              for Biometric Privacy. No biometric template is created,
              processed, stored, transmitted, or received.
            </ListItem>
            <ListItem className={classes.listText}>
              I acknowledge I am over 21 years of age, all information I
              provided is accurate, and I am prohibited from allowing any other
              person to access or use my verified Private Identity account.
            </ListItem>
            <ListItem className={classes.listText}>
              I agree to register for an account using my face images and my US
              state issued driving license or identity card. Private Identity,
              and our third-party enrollment and identity proofing service
              providers IDEMIA and CentralAMS, may share, use and maintain the
              images and information you provide, and the information on file
              with other third-party service providers to further verify your
              identity, to protect against or prevent actual or potential fraud
              or unauthorized use of the Service, and to establish, maintain and
              authenticate your verified digital identity, for the duration of
              our business relationship.
            </ListItem>
            <ListItem className={classes.listText}>
              I agree to receive email and SMS messages for the purpose of
              registering and maintaining an account.
            </ListItem>
            <ListItem className={classes.listText}>
              I have read and accepted the Private Identity LLC{" "}
              <Link
                href="https://github.com/openinfer/PrivateIdentity/wiki/Terms-of-Use"
                onClick={() =>
                  window.open(
                    "https://github.com/openinfer/PrivateIdentity/wiki/Terms-of-Use",
                    "_blank"
                  )
                }
              >
                Terms of Use
              </Link>{" "}
              and{" "}
              <Link
                href="https://github.com/openinfer/PrivateIdentity/wiki/Privacy-Policy"
                onClick={() =>
                  window.open(
                    "https://github.com/openinfer/PrivateIdentity/wiki/Privacy-Policy",
                    "_blank"
                  )
                }
              >
                Privacy Policy
              </Link>
              , CentralAMS{" "}
              <Link
                href="https://www.centralams.com/terms-of-use/"
                onClick={() =>
                  window.open(
                    "https://www.centralams.com/terms-of-use/",
                    "_blank"
                  )
                }
              >
                Terms of Use
              </Link>{" "}
              and{" "}
              <Link
                href="https://www.centralams.com/privacy-policy/"
                onClick={() =>
                  window.open(
                    "https://www.centralams.com/privacy-policy/",
                    "_blank"
                  )
                }
              >
                Privacy Policy
              </Link>
              , and the IDEMIA{" "}
              <Link
                href="https://na.idemia.com/terms/"
                onClick={() =>
                  window.open("https://na.idemia.com/terms/", "_blank")
                }
              >
                Terms of Use
              </Link>{" "}
              and{" "}
              <Link
                href="https://na.idemia.com/privacy/"
                onClick={() =>
                  window.open("https://na.idemia.com/privacy/", "_blank")
                }
              >
                Privacy Policy
              </Link>
              .
            </ListItem>
          </List>
        </Card>
      </Grid>
      <CvsButton
        title={"Accept and continue"}
        onClick={() => {
          setStep(STEPS.REGISTER_FORM);
          setPrevStep(STEPS.REGISTER_CONSENT);
        }}
        skin={skin}
      />
      <CvsButton
        title={"No, I do not consent"}
        onClick={() => navigate("/")}
        skin={skin}
      />
    </>
  );
};

export default DatabaseConsent;
